import { forwardRef, Textarea, TextareaProps, useMergeRefs } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import TextareaAutosize from 'react-textarea-autosize';

import { useFieldValidationStates } from '../hooks/useFieldValidationStates';
import { SimpleField, SimpleXProps } from './SimpleField';
import { useSimpleFormContext } from './SimpleForm';

type SimpleTextareaProps = SimpleXProps & TextareaProps;

export const SimpleTextarea = forwardRef(
  (
    { name, label, helper, rows = 4, placeholder, ignoreOnBlur, variant = 'filled', ...rest }: SimpleTextareaProps,
    ref,
  ) => {
    const { simpleOnBlur } = useSimpleFormContext();
    const { register } = useFormContext();
    const { isInvalid } = useFieldValidationStates(name as string);
    const { ref: formRef, ...inputProps } = register(name);
    const mergedRef = useMergeRefs(formRef, ref);

    const formProps = register(name);

    const onBlur = (event: any) => {
      if (ignoreOnBlur) return;

      formProps.onBlur(event);
      simpleOnBlur?.(event);
    };

    return (
      <SimpleField<TextareaProps> name={name} label={label} helper={helper} variant={variant} {...rest}>
        <Textarea
          as={TextareaAutosize}
          {...inputProps}
          rows={rows}
          minH="20"
          {...formProps}
          ref={mergedRef}
          onBlur={onBlur}
          placeholder={placeholder}
          isDisabled={rest.isDisabled}
          variant={variant}
          p="3"
          isInvalid={isInvalid}
        />
      </SimpleField>
    );
  },
);
